import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { oneOfType, object, func, array, bool, string, node } from 'prop-types'
import { css } from '@emotion/react'
import { ToastWrapper } from '@livechat/design-system-react-components'

import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import { notificationsCreate } from '@/store/notifications'
import { DESIGN_SYSTEM_THEME, NOTIFICATIONS } from '@/constants'
import GlobalStyles from './global-styles'
import { navStyles, mainStyles, contentStyles } from './layout-styles'

const toastCss = css`
  top: 100px;
  z-index: 140000;
  max-width: 460px;
`

const navWrapperCss = css`
  background-color: white;
  position: sticky;
  z-index: 10000;
  top: 0;
`

const Layout = ({
  app,
  service,
  expert,
  category,
  developer,
  children,
  notifications,
  overrideStyles = {},
  HeaderComponent = Navigation,
  hideFooter = false,
  addNotification,
  showCart = true,
  showSearch = true,
  hideBottomPadding,
  LogoComponent,
  className,
}) => {
  useEffect(() => {
    const notification = localStorage.getItem('notification')
    const parsedNotification = notification ? JSON.parse(notification) : null

    if (
      parsedNotification &&
      parsedNotification.type === NOTIFICATIONS.TYPES.PAGE_LOAD
    ) {
      const instantNotification = {
        ...parsedNotification,
        type: NOTIFICATIONS.TYPES.INSTANT,
      }

      addNotification(instantNotification)
      localStorage.clear('notification')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const mergedStyles = {
    nav: navStyles,
    main: mainStyles,
    content: contentStyles,
    ...overrideStyles,
  }

  return (
    <div
      css={mergedStyles.container}
      className={`${className ?? ''} ${DESIGN_SYSTEM_THEME}`}
    >
      <ToastWrapper
        data-test="toast-wrapper"
        fixed={true}
        verticalPosition="top"
        horizontalPosition="center"
        toasts={notifications}
        css={toastCss}
      />

      <GlobalStyles />

      <div css={navWrapperCss}>
        <nav css={mergedStyles.nav}>
          <HeaderComponent
            app={app}
            service={service}
            expert={expert}
            category={category}
            developer={developer}
            showCart={showCart}
            showSearch={showSearch}
            LogoComponent={LogoComponent}
          />
        </nav>
      </div>

      <main css={mergedStyles.main(hideFooter, hideBottomPadding)}>
        <div css={mergedStyles.content(hideBottomPadding)}>{children}</div>
      </main>

      {!hideFooter && <Footer />}
    </div>
  )
}

Layout.propTypes = {
  children: node,
  app: object,
  service: object,
  expert: object,
  developer: object,
  category: object,
  notifications: array,
  overrideStyles: object,
  HeaderComponent: oneOfType([func, object]),
  hideFooter: bool,
  addNotification: func,
  showCart: bool,
  showSearch: bool,
  hideBottomPadding: bool,
  LogoComponent: oneOfType([func, object]),
  className: string,
}

const mapStateToProps = (state) => {
  return {
    notifications: state.notifications.items,
  }
}

const mapDispatchToProps = (dispatch) => ({
  addNotification: (notification) => {
    dispatch(notificationsCreate(notification))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
